/*
 * SANDBOX: the setup wizard, the home page and the campaign composer opened
 * with no sign-in at all (`/start`, `/start/home`, `/start/campaign`).
 *
 * Entered by the public page on mount, never left (a reload leaves it).
 * While on, data hooks return nothing instead of calling the backend, and
 * the screens run on demo data and on the in-memory record, never saved.
 *
 * Lives outside the onboarding module so shared hooks can read the flag
 * without importing UI code.
 */
let sandbox = false

export const enterSandbox = () => {
   sandbox = true
}

export const isSandbox = () => sandbox

/** For SWR keys: `useSWR(gated(key), fetcher)` fetches nothing in the sandbox. */
export const gated = <T>(key: T): T | null => (sandbox ? null : key)
